<template>
    <div class="custom-card">
      <a-tabs default-active-key="1" size="small" @change="callback">
        <a-tab-pane key="1" tab="销售合同">
          <sale-tabs></sale-tabs>
        </a-tab-pane>
        <a-tab-pane key="2" tab="采购合同" force-render>
          <purchase-tabs></purchase-tabs>
        </a-tab-pane>
      </a-tabs>
    </div>
</template>

<script>
import purchaseTabs from './page/purchaseTabs.vue'
import saleTabs from './page/saleTabs.vue'
import baseCard from '@/CrComponents/Card/Card'

export default {
  components: {
    purchaseTabs,
    saleTabs,
    baseCard,
  },
  data() {
    return {
      cardOption: {},
      searchModel: {},
    }
  },
  methods: {
    callback() {},
  },
}
</script>

<style>
  .ant-tabs-bar.ant-tabs-top-bar.ant-tabs-small-bar{
    border-bottom:#f0f2f5 20px solid ;
    padding: 0 24px;
  }
  .ant-tabs-tabpane.ant-tabs-tabpane-active{
    padding: 16px 24px;
    padding-top: 0;
  }
  .custom-card{
    background: #FFFFFF;
    padding: 0px;
    padding-top:0px;
  }
</style>

